// PrivacyPolicy.jsx
import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, Row, Col, Switch, Checkbox, InputNumber, DatePicker, TimePicker, Select, Radio } from 'antd';

import { BreathAPIs } from '../../APIs/BreathAPIs';
import { toast } from 'react-toastify';
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';
import dayjs from 'dayjs';
import { countries as countriesData, timeZone } from '../../resources/LocationData';




const AddLocation = ({ modalVisible, closeModal, submitFeedback }) => {
    const handleCancel = () => {
        closeModal();
    };


    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isAbsRevShare, setIsAbsRevShare] = useState("no");
    const [rate, setRate] = useState(0.0);
    const [locationFormData, setLocationFormData] = useState({
        locationName: "",
        active: false,
        address: {
            streetAndNumber: "",
            postalCode: "",
            city: "",
            state: "",
            country: ""
        },
        coordinates: [null, null],
        operatorName: "",
        timezone: null,
        freeChargingComponent: {
            maxFreeChargeDuration: "",
            enableFreeCharge: "",
            startTime: "",
        },
        splitFactor:0,
        revenueType: null,
        perPortFees:{
            fees:0,
            dateOfChange:null
        },
      
        selectCharger:true,
        maxChargeDuration:6,
        idleFee:0.25,
        unutilizationThreshold:0.7,
        unutilizationFeePercent:1,
        relatedLocations:[],
        absoluteRevShare:0,
        subLocationType: null,
        enableThirdPartyRedirect: false,
        thirdPartyRedirectUrl: '',
        guestUserAccessible: false
    });

    const { Option } = Select;
    const [form] = Form.useForm();

    const isValidUrl = (url) => {
        if (!url) return false;
        try {
            const parsed = new URL(url);
            return parsed.protocol === 'http:' || parsed.protocol === 'https:';
        } catch (error) {
            return false;
        }
    };

    const locationSubmit = async () => {
        if (locationFormData.enableThirdPartyRedirect && !isValidUrl(locationFormData.thirdPartyRedirectUrl)) {
            toast.error('Please enter a valid third party redirect URL.');
            return;
        }
        const formattedData = {
            locationName: locationFormData.locationName,
            active: locationFormData.active || false,
            address: {
                streetAndNumber: locationFormData.address.streetAndNumber,
                postalCode: locationFormData.address.postalCode,
                city: locationFormData.address.city,
                state: locationFormData.address.state,
                country: locationFormData.address.country
            },
            coordinates: [parseFloat(locationFormData.coordinates[0]), parseFloat(locationFormData.coordinates[1])],
            operatorName: locationFormData.locationName,
            timezone: locationFormData.timezone,
            splitFactor:locationFormData.splitFactor,
            revenueType:locationFormData.revenueType,
            perPortFees:{
                fees:locationFormData.perPortFees.fees,
                dateOfChange:locationFormData.perPortFees.dateOfChange
            },
            selectCharger:locationFormData.selectCharger,
            unutilizationThreshold:locationFormData.unutilizationThreshold,
            unutilizationFeePercent:locationFormData.unutilizationFeePercent,
            maxChargeDuration:locationFormData.maxChargeDuration,
            idleFee:locationFormData.idleFee,
            revenueModel:[{
                revenueType:locationFormData.revenueType,
                PPA: locationFormData.perPortFees.fees,
                RSF: locationFormData.splitFactor,
                MUFA: locationFormData.muf,
                MUFChargerCount: locationFormData.mufChargerCount,
                startDate:new Date(),
                endDate:null
            }],
            absoluteRevShare:locationFormData.absoluteRevShare,
            subLocationType:locationFormData.subLocationType,
            enableThirdPartyRedirect:locationFormData.enableThirdPartyRedirect,
            thirdPartyRedirectUrl:locationFormData.thirdPartyRedirectUrl,
            guestUserAccessible:locationFormData.guestUserAccessible


        };

        if (locationFormData.freeChargingComponent.enableFreeCharge) {
            const startTime = new Date(locationFormData.freeChargingComponent.startTime);
            const maxFreeChargeDuration = parseInt(locationFormData.freeChargingComponent.maxFreeChargeDuration, 10);
            const endTime = new Date(startTime.getTime() + (maxFreeChargeDuration * 60000)); // Convert minutes to milliseconds

            formattedData.freeChargingComponent = {
                maxFreeChargeDuration: (locationFormData.freeChargingComponent.maxFreeChargeDuration * 60),
                enableFreeCharge: locationFormData.freeChargingComponent.enableFreeCharge,
                startTime: locationFormData.freeChargingComponent.startTime,
                endTime: endTime.toISOString()
            };
        }

        try {
            setIsSubmitting(true);
            console.log('formatted Data:',formattedData);
            const res = await BreathAPIs.addLocation(formattedData);
            form.resetFields();
            setLocationFormData({
                locationName: "",
                active: false,
                address: {
                    streetAndNumber: "",
                    postalCode: "",
                    city: "",
                    state: "",
                    country: ""
                },
                coordinates: [null, null],
                operatorName: "",
                timezone: null,
                freeChargingComponent: {
                    maxFreeChargeDuration: "",
                    enableFreeCharge: "",
                    startTime: "",
                },
                splitFactor:0,
                revenueType: null,
                perPortFees:{
                    fees:0,
                    dateOfChange:null
                },
                unutilizationFeePercent:0,
                unutilizationThreshold:0,
                selectCharger:true,
                maxChargeDuration:6,
                idleFee:0.25,
                unutilizationThreshold:0.7,
                unutilizationFeePercent:1,
                absoluteRevShare:0,
                subLocationType: null,
                enableThirdPartyRedirect: false,
                thirdPartyRedirectUrl: '',
                guestUserAccessible: false

            })
            submitFeedback(res.data.message);
            setIsSubmitting(false);
            closeModal();
        } catch (error) {
            toast.error('Error adding location.');
            setIsSubmitting(false);
        }
    };

    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    useEffect(() => {
        setCountryOptions(Object.keys(countriesData));
    }, []);

    const handleCountryChange = (selectedCountry) => {
        setLocationFormData(prev => ({
            ...prev,
            address: {
                ...prev.address,
                country: selectedCountry,
                state: '',
                city: '',
            },
        }));
        setStateOptions(Object.keys(countriesData[selectedCountry] || {}));
        setCityOptions([]);
        form.resetFields(['city']);
        form.resetFields(['state']);
    };

    const handleStateChange = (selectedState) => {
        setLocationFormData(prev => ({
            ...prev,
            address: {
                ...prev.address,
                state: selectedState,
                city: '',
            },
        }));
        setCityOptions(countriesData[locationFormData.address.country]?.[selectedState] || []);
        form.resetFields(['city']);


    };

    const handleCityChange = (selectedCity) => {
        setLocationFormData(prev => ({
            ...prev,
            address: {
                ...prev.address,
                city: selectedCity,
            },
        }));

    };

    const handleRevenueTypeChange = (revenueType) => {
        // revenueType === 'perPortFee'
        //     ? setLocationFormData(prev => ({
        //         ...prev,
        //         revenueType: revenueType,
        //         splitFactor: 1.0
        //     }))
        //     : setLocationFormData(prev => ({
        //         ...prev,
        //         revenueType: revenueType,
        //         splitFactor: locationFormData.splitFactor,
        //         perPortFees:{
        //             fees:0,
        //             dateOfChange: null
        //            }
        //     }));
        if(revenueType === 'per_port'){
           const temp = new Date();
           const dateOfChangeUTC = temp.toISOString().slice(0, -1);
        setLocationFormData(prev => ({
            ...prev,
            revenueType: revenueType,
            splitFactor: 1.0,
               perPortFees:{
                fees:0,
                dateOfChange: dateOfChangeUTC
               }
        }))
       } 
       else if(revenueType === 'rev_share'){

           setLocationFormData(prev => ({
               ...prev,
               revenueType: revenueType,
               splitFactor: 0,
               perPortFees:{
                   fees:0,
                   dateOfChange: null
                  }
           }));
       }
       else{

        const temp = new Date();
        const dateOfChangeUTC = temp.toISOString().slice(0, -1);
        setLocationFormData(prev => ({
            ...prev,
            revenueType: revenueType,
            splitFactor: 0,
            perPortFees:{
                fees:0,
                dateOfChange: dateOfChangeUTC
               }
        }));

       }
         
        setIsAbsRevShare("no");
        setRate(0.0);
        setLocationFormData(prev => ({ ...prev, absoluteRevShare: 0 }))
    };

    const handlePerPortFee = (perPortFee) => {
        if(locationFormData.revenueType === 'per_port'||locationFormData.revenueType === 'hybrid' ){
            const temp = new Date();
            const dateOfChangeUTC = temp.toISOString().slice(0, -1);
             setLocationFormData(prev => ({
                ...prev,
               perPortFees:{
                fees:perPortFee,
                dateOfChange: dateOfChangeUTC
               }
            }))
        }
    };

    return (
        <Modal
            title="Add Location"
            visible={modalVisible}
            onCancel={handleCancel}
            footer={null}
            width={window.innerWidth <= 768 ? "100%" : "50%"}
        >
            <>
            {
                console.log('location form data ',locationFormData)
            }
            </>
            <Form form={form} 
            //  initialValues={locationFormData}
             onFinish={locationSubmit} layout={'vertical'} id='locationForm' >
                <div className="row">
                    <div className="col-md-6">
                        <Form.Item label="Location Name" name="locationName" rules={[{ required: true, message: "Please input location name!" }]}>
                            <Input value={locationFormData.locationName} onChange={e => setLocationFormData(prev => ({ ...prev, locationName: e.target.value }))} placeholder="Enter Location Name" />
                        </Form.Item>

                        <Form.Item label="Country" name="country" rules={[{ required: true, message: "Please input country!" }]}>
                            <Select
                                value={locationFormData.address.country}

                                onChange={handleCountryChange}
                                placeholder="Select Country"
                                allowClear
                            >
                                {countryOptions.map(country => (
                                    <Option key={country} value={country}>{country}</Option>
                                ))}
                            </Select>

                        </Form.Item>

                        <Form.Item label="State" name="state" rules={[{ required: true, message: "Please input state!" }]}>
                            <Select
                                value={locationFormData.address.state}
                                onChange={handleStateChange}
                                placeholder="Select State"
                                allowClear
                                showSearch
                            >
                                {stateOptions.map(state => (
                                    <Option key={state} value={state}>{state}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item label="City" name="city" rules={[{ required: true, message: "Please input city!" }]}>
                            <Select
                                value={locationFormData.address.city}
                                onChange={handleCityChange}
                                placeholder="Select City"
                                allowClear
                                showSearch
                            >
                                {cityOptions.map(city => (
                                    <Option key={city} value={city}>{city}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item label="Street and Number" name="streetAndNumber" rules={[{ required: true, message: "Please input street and number!" }]}>
                            <Input value={locationFormData.address.streetAndNumber} onChange={e => setLocationFormData(prev => ({ ...prev, address: { ...prev.address, streetAndNumber: e.target.value } }))} placeholder="Enter Street and Number" />
                        </Form.Item>

                        <Form.Item label="Unutilization Fee Factor"  
                    // rules={[{ required: true, message: "Please input unutilization fee percent !" }]}
                    >
                    <InputNumber
                            style={{ width: '100%' }}
                            min={1}
                            max={100}
                            // defaultValue={locationFormData.unutilizationFeePercent}
                            // defaultValue={1}
                            placeholder="1%"
                            value={locationFormData.unutilizationFeePercent }
                            onChange={(value) => setLocationFormData(prev => ({ ...prev, unutilizationFeePercent: value }))}
                          
                        />
                        </Form.Item>
                     
                  
                    <Form.Item label="Maximum Charging Duration ( hrs )"  rules={[{ required: true, message: "Please input maximum charging duration !" }]}>
                    <InputNumber
                            style={{ width: '100%' }}
                            min={1}
                            // defaultValue={6}
                            step={1}
                            placeholder="6"
                            value={locationFormData.maxChargeDuration}
                            onChange={(value) => setLocationFormData(prev => ({ ...prev, maxChargeDuration: value }))}
                          
                        />
                        </Form.Item>
                                {/* {console.log('select charger: ',locationFormData.selectCharger)} */}
                        <Form.Item label="Allow Charger Selection ( Initiate Now )"  rules={[{ required: true, message: "Please select charger selection!" }]}>
                            <Select
                                value={locationFormData.selectCharger}
                                onChange={(value) => setLocationFormData(prev => ({ ...prev, selectCharger: value }))}
                                placeholder='Select True / False'
                            >
                                    <Option key={true} value={true}>True</Option>
                                    <Option key={false} value={false}>False</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item label="Unutilization Threshold"  rules={[{ required: true, message: "Please input unutilization threshold !" }]}>
                    <InputNumber
                            style={{ width: '100%' }}
                            min={0}
                            max={1}
                            step={0.1}
                            // defaultValue={0.7}
                            placeholder="0.7"
                            value={locationFormData.unutilizationThreshold}
                            onChange={(value) => setLocationFormData(prev => ({ ...prev, unutilizationThreshold: value }))}
                          
                        />
                        </Form.Item>
                 
                  
                    </div>

                    <div className="col-md-6">
                        <Form.Item label="Postal Code" name="postalCode" rules={[{ required: true, message: "Please input postal code!" }]}>
                            <Input value={locationFormData.address.postalCode} onChange={e => setLocationFormData(prev => ({ ...prev, address: { ...prev.address, postalCode: e.target.value } }))} placeholder="Enter Postal Code" />
                        </Form.Item>

                        <Form.Item label="Longitude" name="Longitude" rules={[{ required: true, message: "Please input longitude!" }]}>
                            <Input type='number' value={locationFormData.coordinates[0]} onChange={e => setLocationFormData(prev => ({ ...prev, coordinates: [e.target.value, prev.coordinates[1]] }))} placeholder="-73.935242" />
                        </Form.Item>

                        <Form.Item label="Latitude" name="Latitude" rules={[{ required: true, message: "Please input latitude!" }]}>
                            <Input type='number' value={locationFormData.coordinates[1]} onChange={e => setLocationFormData(prev => ({ ...prev, coordinates: [prev.coordinates[0], e.target.value] }))} placeholder="40.730610" />
                        </Form.Item>

                        {/* <Form.Item label="Operator Name" name="operatorName" rules={[{ required: true, message: "Please input operator name!" }]}>
                            <Input value={locationFormData.operatorName} onChange={e => setLocationFormData(prev => ({ ...prev, operatorName: e.target.value }))} placeholder="Enter Operator Name" />
                        </Form.Item> */}

                        <Form.Item label="Timezone" name="timezone" rules={[{ required: true, message: "Please select timezone!" }]}>
                            <Select
                                value={locationFormData.timezone || undefined}
                                onChange={(value) => setLocationFormData(prev => ({ ...prev, timezone: value }))}
                                placeholder="Select Time Zone"
                                allowClear
                                showSearch
                            >
                                {timeZone.map(zone => (
                                    <Option key={zone.name} value={zone.name}>{`${zone.offset} ${zone.name}`}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="Revenue Type" name="revenueType" rules={[{ required: true, message: "Please select revenue type!" }]}>
                            <Select
                                
                                onChange={handleRevenueTypeChange}
                                placeholder="Select Revenue Type"
                            >
                                <Option key={'rev_share'} value={'rev_share'}>Revenue Share</Option>  
                                <Option key={'per_port'} value={'per_port'}>Per Port Fee</Option>
                                <Option key={'hybrid'} value={'hybrid'}>Hybrid</Option>
                                <Option key={"muf"} value={"muf"}>MUF</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item label="Split Factor" rules={[{ required: true, message: "Please input split factor!" }]}>
                            <InputNumber
                                style={{ width: '100%' }}
                                min={0}
                                max={1}
                                step={0.1}
                                placeholder="0.6"
                                // defaultValue={0.3}
                                disabled={locationFormData.revenueType === 'per_port' || isAbsRevShare === 'yes' }
                                value={locationFormData.splitFactor}
                                onChange={(value) => setLocationFormData(prev => ({ ...prev, splitFactor: value }))}
                                formatter={(val) => {
                                    if (val === null || val === undefined || val === '') return '';
                                    const n = typeof val === 'number' ? val : parseFloat(val);
                                    if (Number.isNaN(n)) return '';
                                    return n.toFixed(2);
                                }}
                                // keep the original numeric value in state (no rounding)
                                parser={(val) => {
                                    if (val === null || val === undefined || val === '') return null;
                                    const s = String(val).replace(/[^\d.-]/g, '');
                                    const n = parseFloat(s);
                                    return Number.isNaN(n) ? null : n;
                                }}
                            />
                        </Form.Item>
                        {locationFormData.revenueType === 'rev_share' &&
                            <>
                                <Form.Item label="Absolute Rev Share?">
                                    <Radio.Group
                                        value={isAbsRevShare === "yes" ? 'yes' : 'no'}
                                        onChange={(e) => {
                                            setIsAbsRevShare(e.target.value)
                                            setLocationFormData(prev => ({ ...prev, splitFactor: 0 }))
                                            if(e.target.value ===  'no'){
                                                setLocationFormData(prev => ({ ...prev, absoluteRevShare: 0 }))
                                            }
                                        }}
                                        options={[
                                            { label: 'Yes', value: 'yes' },
                                            { label: 'No', value: 'no' },
                                        ]}
                                        optionType="button"
                                        buttonStyle="solid"
                                    />
                                </Form.Item>
                                
                                <Form.Item label="Absolute Rev Share Amount ($)" rules={[{ required: isAbsRevShare === 'yes' , message: "Please input rev share amount towards BreatheEV!" }]}>
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                    max={1}
                                    step={0.1}
                                    placeholder="0.06"
                                    // defaultValue={0.3}
                                    disabled={isAbsRevShare === 'no'}
                                    value={locationFormData.absoluteRevShare}
                                    onChange={(value) => {
                                        setLocationFormData(prev => ({ ...prev, absoluteRevShare: value }))
                                        rate !==0 ? 
                                        setLocationFormData(prev => ({ ...prev, splitFactor: (1 - (value / rate)) })) :
                                        setLocationFormData(prev => ({ ...prev, splitFactor: 0 }))
                                    }
                                }

                                />
                            </Form.Item>
                             <Form.Item label="Rate/kWh ($)" rules={[{ required: isAbsRevShare === 'yes' , message: "Please input rate" }]}>
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                    max={1}
                                    step={0.1}
                                    placeholder="0.35"
                                    // defaultValue={0.3}
                                    disabled={isAbsRevShare === 'no'}
                                    value={rate}
                                    onChange={(value) => {
                                        setLocationFormData(prev => ({ ...prev, splitFactor: (1 - (locationFormData.absoluteRevShare / value)) }));
                                        setRate(value)
                                    }
                                    }

                                />
                            </Form.Item>
                    </>
                    }
                       
                        <Form.Item label="Per Port Fee"    rules={[
                                                locationFormData.revenueType === 'per_port' ||  locationFormData.revenueType === 'hybrid' 
                                                    ? { required: true, message: "Please input per port fee!" } 
                                                    : {}
                                            ]}>
                        <InputNumber
                            min={0}
                            placeholder="$55"
                            style={{ width: '100%' }}
                            value={locationFormData.perPortFees.fees}
                            onChange={handlePerPortFee}
                            disabled={locationFormData.revenueType === 'rev_share' || locationFormData.revenueType === 'muf'} 

                          
                        />
                    </Form.Item>
                    {
                            locationFormData.revenueType === 'muf' && (<>
                                <Form.Item label="MUF Rate ($)" rules={[
                                    { required: true, message: "Please input MUF rate!" }
                                ]}>
                                    <InputNumber
                                        min={0}
                                        placeholder="$7"
                                        // defaultValue={0.25}
                                        style={{ width: '100%' }}
                                        value={locationFormData.muf}
                                        // onChange={e => setLocationFormData(prev => ({ ...prev, idleFee: e.target.value }))}
                                        onChange={(value) => { setLocationFormData(prev => ({ ...prev, muf: value })) }}
                                    />
                                </Form.Item>
                                <Form.Item label="No of chargers for MUF" rules={[
                                    { required: true, message: "Please input no of chargers for MUF!" }
                                ]}>
                                    <InputNumber
                                        min={0}
                                        placeholder="10"
                                        style={{ width: '100%' }}
                                        value={locationFormData.mufChargerCount}
                                        onChange={(value) => { setLocationFormData(prev => ({ ...prev, mufChargerCount: value })) }}
                                    />
                                </Form.Item>
                            </>
                            )
                        }

                    <Form.Item label="Idle Fee ( per min ) "   rules={[
                                               { required: true, message: "Please input idle fee!" } 
                                              
                                            ]}>
                        <InputNumber
                            min={0}
                            // placeholder="$7"
                            // defaultValue={0.25}
                            style={{ width: '100%' }}
                            value={locationFormData.idleFee}
                            // onChange={e => setLocationFormData(prev => ({ ...prev, idleFee: e.target.value }))}
                            onChange={(value)=>{setLocationFormData(prev => ({ ...prev, idleFee: value }))}}
                           

                          
                        />
                    </Form.Item>

                    <Form.Item label="Sub location type (Optional)">

                            <Select
                                allowClear
                                onChange={(value) => setLocationFormData(prev => ({ ...prev, subLocationType: value }))}
                                placeholder="Select sub location type"
                            >
                                <Option key={'CONDO'} value={'CONDO'}>CONDO</Option>
                                <Option key={'MULTI_UNIT'} value={'MULTI_UNIT'}>MULTI UNIT</Option>
                            </Select>
                    </Form.Item>

                    </div>

                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Item label="Redirect to Third Party on Scan" valuePropName="checked">
                                    <Switch checked={locationFormData.enableThirdPartyRedirect} onChange={(checked) => setLocationFormData(prev => ({ ...prev, enableThirdPartyRedirect: checked }))} />
                                </Form.Item>
                            </div>
                            <div className="col-md-6">
                                {locationFormData.enableThirdPartyRedirect &&
                                    <Form.Item
                                        label="Third Party Redirect URL"
                                        rules={[{ required: true, message: "Please enter a valid redirect URL!" }]}
                                        validateStatus={isValidUrl(locationFormData.thirdPartyRedirectUrl) ? '' : 'error'}
                                        help={isValidUrl(locationFormData.thirdPartyRedirectUrl) ? '' : 'Enter a valid http(s) URL'}
                                    >
                                        <Input placeholder="https://example.com/validate" value={locationFormData.thirdPartyRedirectUrl} onChange={(e) => setLocationFormData(prev => ({ ...prev, thirdPartyRedirectUrl: e.target.value }))} />
                                    </Form.Item>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Item label="Guest User Accessible" valuePropName="checked">
                                    <Switch checked={locationFormData.guestUserAccessible} onChange={(checked) => setLocationFormData(prev => ({ ...prev, guestUserAccessible: checked }))} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>

{/*
                    <div className="col-md-12 border-secondary mb-3">
                        <div className="card border-dark mb-3">
                            <div className="card-header">Free Charging</div>
                            <div className="card-body text-dark">
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={24} md={8}>
                                        <Form.Item label="Enable Free Charge" name={'enableFreeCharge'} valuePropName="checked">
                                            <Switch checked={locationFormData?.freeChargingComponent?.enableFreeCharge} onChange={checked => setLocationFormData(prev => ({ ...prev, freeChargingComponent: { ...prev.freeChargingComponent, enableFreeCharge: checked } }))} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={8}>
                                        <Form.Item label="Start Time" name={'startTime'} rules={locationFormData?.freeChargingComponent?.enableFreeCharge ? [{ required: true, message: "Please input Start Time!" }] : undefined}>
                                            <TimePicker disabled={locationFormData?.freeChargingComponent?.enableFreeCharge ? false : true} initialValues={dayjs('00:00', 'HH:mm')} format="HH:mm" onChange={date => setLocationFormData(prev => ({ ...prev, freeChargingComponent: { ...prev.freeChargingComponent, startTime: date } }))} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={8}>
                                        <Form.Item label="Max Free Charge Duration (minute)" name={'maxFreeChargeDuration'} rules={locationFormData?.freeChargingComponent?.enableFreeCharge ? [{ required: true, message: "Please input Max Free Charge Duration!" }] : undefined}>
                                            <InputNumber disabled={locationFormData?.freeChargingComponent?.enableFreeCharge ? false : true} min={'0'} value={locationFormData?.freeChargingComponent?.maxFreeChargeDuration} onChange={value => setLocationFormData(prev => ({ ...prev, freeChargingComponent: { ...prev.freeChargingComponent, maxFreeChargeDuration: value } }))} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div> */}



                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Item name="active">
                                    <Checkbox checked={locationFormData.active} onChange={e => setLocationFormData(prev => ({ ...prev, active: e.target.checked }))}>Active</Checkbox>
                                </Form.Item>
                            </div>
                            <div className="col-md-6">
                                <Form.Item style={{ textAlign: 'right' }}>
                                    <ButtonCustom isLoading={isSubmitting} text={isSubmitting ? 'Adding...' : 'Add Location'} type='submit' />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </Modal>
    );
};

export default AddLocation;
